// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IIsAutoEnrollmentPropertyDto
 */
export interface IIsAutoEnrollmentPropertyDto {
    /**
     * 
     * @type {boolean}
     * @memberof IIsAutoEnrollmentPropertyDto
     */
    is_auto_enrollment?: boolean;
    /**
     * 
     * @type {string}
     * @memberof IIsAutoEnrollmentPropertyDto
     */
    is_auto_enrollment_state?: IIsAutoEnrollmentPropertyDtoIsAutoEnrollmentStateEnum;
}

/**
* @export
* @enum {string}
*/
export enum IIsAutoEnrollmentPropertyDtoIsAutoEnrollmentStateEnum {
    MODIFIABLE = 'MODIFIABLE',
    LOCKED = 'LOCKED',
    HIDDEN = 'HIDDEN',
    REQUIRED_AT_PLAN = 'REQUIRED_AT_PLAN',
    REQUIRED_AT_ALL_LEVELS = 'REQUIRED_AT_ALL_LEVELS'
}


/**
 * Check if a given object implements the IIsAutoEnrollmentPropertyDto interface.
 */
export function instanceOfIIsAutoEnrollmentPropertyDto(value: object): value is IIsAutoEnrollmentPropertyDto {
    return true;
}

export function IIsAutoEnrollmentPropertyDtoFromJSON(json: any): IIsAutoEnrollmentPropertyDto {
    return IIsAutoEnrollmentPropertyDtoFromJSONTyped(json, false);
}

export function IIsAutoEnrollmentPropertyDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IIsAutoEnrollmentPropertyDto {
    if (json == null) {
        return json;
    }
    return {
        
        'is_auto_enrollment': json['is_auto_enrollment'] == null ? undefined : json['is_auto_enrollment'],
        'is_auto_enrollment_state': json['is_auto_enrollment_state'] == null ? undefined : json['is_auto_enrollment_state'],
    };
}

export function IIsAutoEnrollmentPropertyDtoToJSON(json: any): IIsAutoEnrollmentPropertyDto {
    return IIsAutoEnrollmentPropertyDtoToJSONTyped(json, false);
}

export function IIsAutoEnrollmentPropertyDtoToJSONTyped(value?: IIsAutoEnrollmentPropertyDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'is_auto_enrollment': value['is_auto_enrollment'],
        'is_auto_enrollment_state': value['is_auto_enrollment_state'],
    };
}

